(() => {
  const initializedRoots = new WeakSet();
  const rootSelector = '.custom-index-showcase';

  const initializeShowcase = (root) => {
    if (initializedRoots.has(root)) return;
    initializedRoots.add(root);

    const triggers = Array.from(root.querySelectorAll('[data-routine-trigger]'));
    const panels = Array.from(root.querySelectorAll('[data-routine-panel]'));

    if (triggers.length && panels.length) {
      const activateRoutine = (id) => {
        triggers.forEach((trigger) => {
          const isActive = trigger.dataset.routineTrigger === id;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
          trigger.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.routinePanel === id;
          panel.toggleAttribute('hidden', !isActive);
          panel.classList.toggle('is-active', isActive);
        });
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => activateRoutine(trigger.dataset.routineTrigger));
        trigger.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

          event.preventDefault();
          const currentIndex = triggers.indexOf(trigger);
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextTrigger = triggers[(currentIndex + direction + triggers.length) % triggers.length];
          nextTrigger.focus();
          activateRoutine(nextTrigger.dataset.routineTrigger);
        });
      });

      const activeTrigger = triggers.find((trigger) => trigger.classList.contains('is-active')) || triggers[0];
      activateRoutine(activeTrigger.dataset.routineTrigger);
    }

    const faqItems = Array.from(root.querySelectorAll('.custom-index-showcase__faq details'));
    faqItems.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        faqItems.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });
  };

  const initializeWithin = (container = document) => {
    if (container.matches?.(rootSelector)) initializeShowcase(container);
    container.querySelectorAll?.(rootSelector).forEach(initializeShowcase);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(), { once: true });
  } else {
    initializeWithin();
  }

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
